import { render, staticRenderFns } from "./List.vue?vue&type=template&id=6bb6ce1a&"
import script from "./List.vue?vue&type=script&setup=true&lang=ts&"
export * from "./List.vue?vue&type=script&setup=true&lang=ts&"
import style0 from "./List.vue?vue&type=style&index=0&id=6bb6ce1a&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports